import mediator from '../../modules/mediator';

export default class Voucher {
    constructor(item) {
        this.wrapper = $(item);

        this.toggleVoucher = this.toggleVoucher.bind(this);
        this.deleteVoucher = this.deleteVoucher.bind(this);
    }

    init() {
        this.form = this.wrapper.find('form');
        this.submitAction = this.form.attr('action');
        this.inputBlock = this.wrapper.find('.js-voucherInputBlock');
        this.input = this.wrapper.find('.js-voucherInput');
        this.deleteVoucherBtn = this.wrapper.find('.js-voucherDeleteBtn');
        this.voucherToggle = this.wrapper.find('.js-voucherToggle');
        this.bindings();
    }

    bindings() {
        this.voucherToggle.on('click', this.toggleVoucher);
        this.form.on('submit', (e) => this.updateVoucher() && e.preventDefault());
        this.deleteVoucherBtn.on('click', this.deleteVoucher);
    }

    toggleVoucher() {
        if (this.input.val().length === 0) {
            this.inputBlock.toggle();
            this.wrapper.find('.js-voucherToggle').toggle();
        }
    }

    updateVoucher() {
        $.loadingSpinner(this.wrapper, true);
        return $.ajax({
            url: this.submitAction,
            type: 'POST',
            cache: false,
            data: this.form.serialize()
        }).done(async (response) => {
            if (response.success) {
                mediator.publish('growl', { message: response.message, remove: 2000 });
                const { rebindBasket } = await import('views/basket');
                rebindBasket();
                return;
            }
            $.loadingSpinner(this.wrapper, false);
            this.wrapper.html(response);
            this.init();
        });
    }

    deleteVoucher() {
        const deleteAction = this.deleteVoucherBtn.data('js-voucher-delete');
        $.ajax({
            url: deleteAction,
            type: 'POST',
            cache: false
        }).done((response) => {
            if (response.success) {
                this.wrapper.empty();
                rebindBasket();
            }
        });
    }
}
